import { render, staticRenderFns } from "./BaseRecipient.vue?vue&type=template&id=7de98fb8&"
import script from "./BaseRecipient.vue?vue&type=script&lang=ts&"
export * from "./BaseRecipient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports